import { FormInputsType } from '../input/FormType';
import { SummaryType } from '../input/SummaryType';

export type SendingErrorCategory = 'network' | 'validation' | 'rateLimit' | 'server' | 'unknown';

export type SendingResult = {
  ok: boolean;
  detail?: string;
  category?: SendingErrorCategory;
};

function categorizeStatus(status: number): SendingErrorCategory {
  if (status === 400 || status === 422) return 'validation';
  if (status === 429) return 'rateLimit';
  if (status >= 500) return 'server';
  // 401/403 (Directus permission misconfig) and anything else unexpected:
  // not something the visitor caused, so treat as unknown/generic rather than blaming their input.
  return 'unknown';
}

export default async function sendingRequest(
  d: FormInputsType & SummaryType,
  to: string
): Promise<SendingResult> {
  // Form the request for sending data to the server.
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer t1y9wr7rRZzVHiUnm02WhwYxheYuusQC',
    },

    body: JSON.stringify(d),
  };

  try {
    const response = await fetch(to, options);
    if (!response.ok) {
      const body = await response.text();
      const detail = `HTTP ${response.status} ${response.statusText} – ${body.slice(0, 300)}`;
      // eslint-disable-next-line no-console -- only diagnostic surface we have, see CLAUDE.md known issue
      console.error('sendingRequest failed:', detail);
      return { ok: false, detail, category: categorizeStatus(response.status) };
    }
    return { ok: true };
  } catch (error) {
    const detail = `Erreur réseau: ${error instanceof Error ? error.message : String(error)}`;
    // eslint-disable-next-line no-console -- only diagnostic surface we have, see CLAUDE.md known issue
    console.error('sendingRequest failed:', detail);
    return { ok: false, detail, category: 'network' };
  }
}
